import { render, staticRenderFns } from "./UserRoleSelectedAccess.vue?vue&type=template&id=f7f00a4a&scoped=true&"
import script from "./UserRoleSelectedAccess.vue?vue&type=script&lang=ts&"
export * from "./UserRoleSelectedAccess.vue?vue&type=script&lang=ts&"
import style0 from "./UserRoleSelectedAccess.vue?vue&type=style&index=0&id=f7f00a4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f00a4a",
  null
  
)

export default component.exports